import React from "react";
import { omit } from "lodash";
import { Location } from "@reach/router";
import Layout from "./src/layouts/index";
import SecurityProvider from "./src/components/security-provider";
import { ProvideTargetContext } from "./src/target-context";
import OrderingHome from "./src/templates/index";

export default ({ element, props }) => {
  const { pageContext: { target = 'ordering' } } = props;
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  const {
    location: { pathname },
    pageContext,
  } = props;

  if (
    props.custom404 ||
    element.key === "/404.html" ||
    pathname === "/404.html" ||
    pathname === "/404/"
  ) {
    return element;
  }

  const businessAppConfiguration = pageContext.businessAppConfiguration || {};
  const { recaptchaKey, captchaProvider, hcaptchaKey } = businessAppConfiguration;

  const layoutProps = omit(props, "data");


  return (
    <ProvideTargetContext target={target}>
      <Location>
        {({ location }) => (
          <SecurityProvider
            recaptchaKey={recaptchaKey}
            hcaptchaKey={hcaptchaKey}
            captchaProvider={captchaProvider}
          >
            <Layout {...layoutProps} location={location}>
              {element}
            </Layout>
          </SecurityProvider>
        )}
      </Location>
    </ProvideTargetContext>
  );
};
